import { SearchAddressResponseItem } from "../../../../../common/utils/search-address/search-address.response";
import cargoTranslationsHelper from "../../../../../languages/cargo-translations.helper";
import CargoAddressType from "../../../../../common/types/cargo-address-type";
import CargoAddressTypeSelectOption from "../../common/types/cargo-address-type-select-option";
import CargoAddressAddAddress from "./types/cargo-address-add-address";
import CargoAddressAddAddressSelectOption from "./types/cargo-address-add-address-select-option";

const createAddress = (
  searchAddressResponseItem: SearchAddressResponseItem,
): CargoAddressAddAddress => {
  const address: CargoAddressAddAddress = {
    displayName: searchAddressResponseItem.display_name,
    apartmentNumber: "",
    country: searchAddressResponseItem.address.country,
    countryCode: searchAddressResponseItem.address.country_code,
    houseNumber: searchAddressResponseItem.address.house_number ?? null,
    latitude: Number(searchAddressResponseItem.lat),
    longitude: Number(searchAddressResponseItem.lon),
    street: searchAddressResponseItem.address.road ?? null,
    town:
      searchAddressResponseItem.address.city ??
      searchAddressResponseItem.address.town ??
      searchAddressResponseItem.address.village ??
      null,
    zipCode: searchAddressResponseItem.address.postcode ?? null,
  };

  return address;
};

const createAddressSelectOption = (
  searchAddressResponseItem: SearchAddressResponseItem,
): CargoAddressAddAddressSelectOption => {
  const address = createAddress(searchAddressResponseItem);

  return {
    label: searchAddressResponseItem.display_name,
    value: address,
  };
};

const createAddressSelectOptions = (
  searchAddressResponseItems: SearchAddressResponseItem[],
): CargoAddressAddAddressSelectOption[] => {
  return searchAddressResponseItems.map(createAddressSelectOption);
};

const createAddressTypeSelectOption = (
  item: CargoAddressType,
): CargoAddressTypeSelectOption => {
  const translations =
    cargoTranslationsHelper.getAddressEditTranslations().address.addressType;

  return {
    label: translations[item],
    value: item,
  };
};

const recreateAddressTypeSelectOption = (
  item: CargoAddressType,
): CargoAddressTypeSelectOption => {
  const translations =
    cargoTranslationsHelper.getAddressEditTranslations().address.addressType;

  return {
    label: translations[item],
    value: item,
  };
};

const cargoAddressAddFactory = {
  createAddress,
  createAddressSelectOptions,
  createAddressTypeSelectOption,
  recreateAddressTypeSelectOption,
};

export default cargoAddressAddFactory;
